var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"get-scheme",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"get-scheme_box"},[_c('div',{staticClass:"arrow-right-box"},[_c('svg-icon',{attrs:{"class-name":"arrow-right-icon","icon-class":"arrow-right"}})],1),_c('span',[_vm._v(_vm._s(_vm.$t('navigation.getScheme')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }